import * as constants from './constants';

const notificationsReducer = (state = constants.initialState, action: any) => {
  switch (action.type) {
    case constants.RESET_ERROR:
    case constants.FETCH_USER_HISTORY_SUCCESS:
    case constants.FETCH_USER_HISTORY_FAIL:
    case constants.FETCH_USER_HISTORY:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default notificationsReducer;
